import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import type { GetServerSideProps, NextPage } from 'next';
import styles from './styles.module.scss';

import { PageLayout } from '@/components/pagelay';
import axios from 'axios';
import cName from 'classnames';
import { useRouter } from 'next/router';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Notification } from '@douyinfe/semi-ui';
import Head from 'next/head';
import { PRODDOMAIN, PRODFORNTDOMAIN } from '@/utils';
import { useDate } from '@/utils/useDate';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const showdown = require('showdown');

interface IProps {

}


export const getServerSideProps: GetServerSideProps = async context => {
  const { newsId } = context.query;
  const { data } = await axios.get(`${PRODDOMAIN}/home/news/${newsId}`);

  return {
    props: data.data, // 需要拿props包裹
  };
};

export default (data: any) => {
  const converter = new showdown.Converter();
  const news = {
    1: '/media/show',
    2: '/media/industry',
    3: '/media/exhibitor'
  } as any

  return (
    <div>
      <PageLayout
        crumb={[
          { path: `/media/news_detail/${data?.id}`, name: data?.title_cn },
        ]}
        newsPath={news[data?.category_id]}
      >
        <div className={styles.container}>
          <div className={styles.left}>
            <h2>{data?.title_cn}</h2>
            <div className={styles.share}>
              <span>
                {
                  data?.publish_time ?
                    Object.values(useDate(data?.publish_time))
                      .join('-')
                    : ''
                }
              </span>
              <div>
                <CopyToClipboard text={`${PRODFORNTDOMAIN}/media/news_detail/${data?.id}`}
                  onCopy={() => {
                    Notification.success({
                      content: '复制成功！快去微信分享文章吧！',
                      duration: 3,
                    })
                  }}
                >
                  <div className={styles.wx}></div>
                </CopyToClipboard>
              </div>
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: converter.makeHtml(data?.content_cn) }}
              className={styles.content} />
            <div className={styles.footer}>
              {
                data?.prev_article &&
                <a href={data?.prev_article?.outlink
                  ? data?.prev_article?.outlink
                  : `/media/news_detail/${data?.prev_article?.id}`}>
                  <span>上一篇：{data?.prev_article?.title_cn}</span>
                  <span>{useDate(data?.prev_article?.publish_time).year}年{useDate(data?.prev_article?.publish_time).month}月{useDate(data?.prev_article?.publish_time).day}日</span>
                </a>
              }
              {
                data?.next_article &&
                <a href={data?.next_article?.outlink
                  ? data?.next_article?.outlink
                  : `/media/news_detail/${data?.next_article?.id}`}>
                  <span>下一篇：{data?.next_article?.title_cn}</span>
                  <span>{useDate(data?.next_article?.publish_time).year}年{useDate(data?.next_article?.publish_time).month}月{useDate(data?.next_article?.publish_time).day}日</span>

                </a>
              }
            </div>
          </div>
          <style jsx global>
            {
              `

              `
            }
          </style>
        </div>
      </PageLayout >
    </div >
  );
};